import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterGroupBy',
  standalone: true,
})
export class FilterGroupBy implements PipeTransform {
  transform(filters: any, groupBy: string): any {
    let resultFilters = [];
    if (groupBy === 'all') {
      resultFilters = filters;
    } else {
      for (const filter of filters) {
        if (filter.groupBy === groupBy) {
          resultFilters.push(filter);
        }
      }
    }
    return resultFilters;
  }
}
